// src/components/analytics/TrendChart.js - Trend analysis line chart
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const TrendChart = ({ data, period = 'weekly' }) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-gray-500 dark:text-shayek-dark-500">
        No trend data available
      </div>
    );
  }

  // Format date for display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (period === 'daily') {
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    } else if (period === 'weekly') {
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    } else {
      return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
    }
  };

  const chartData = data.map(item => ({
    date: formatDate(item.date),
    total: item.total || 0,
    anonymous: item.anonymous || 0,
    verified: item.verified || 0
  }));

  const isDark = document.documentElement.classList.contains('dark');
  const gridColor = isDark ? '#333333' : '#e5e7eb';
  const axisColor = isDark ? '#8A8A8A' : '#6b7280';
  const tooltipBg = isDark ? '#2A2A2A' : '#fff';
  const tooltipBorder = isDark ? '#333333' : '#e5e7eb';
  const tooltipText = isDark ? '#E0E0E0' : '#000';

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={gridColor} />
        <XAxis
          dataKey="date"
          stroke={axisColor}
          style={{ fontSize: '12px' }}
          tick={{ fill: axisColor }}
          interval="preserveStartEnd"
        />
        <YAxis 
          stroke={axisColor}
          style={{ fontSize: '12px' }}
          tick={{ fill: axisColor }}
        />
        <Tooltip 
          contentStyle={{ 
            backgroundColor: tooltipBg, 
            border: `1px solid ${tooltipBorder}`,
            borderRadius: '8px',
            padding: '8px',
            color: tooltipText
          }}
          labelStyle={{ color: tooltipText }}
        />
        <Legend 
          wrapperStyle={{ paddingTop: '20px', color: axisColor }}
        />
        <Line 
          type="monotone" 
          dataKey="total" 
          stroke="#751F19" 
          strokeWidth={2}
          name="Total Reports"
          dot={{ fill: '#751F19', r: 4 }}
        />
        <Line 
          type="monotone" 
          dataKey="anonymous" 
          stroke="#8b5cf6" 
          strokeWidth={2}
          name="Anonymous"
          dot={{ fill: '#8b5cf6', r: 4 }}
        />
        <Line 
          type="monotone" 
          dataKey="verified" 
          stroke="#10b981" 
          strokeWidth={2}
          name="Verified"
          dot={{ fill: '#10b981', r: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default TrendChart;

